export default {
  tagContent: {
    id: 'pdp_historical_price_tag_content',
    defaultMessage: '{differencePercentage}% lower than the historical average',
  },
}
